/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_DeleteInputs */

const cs_settings_venues_delete = /** @type {(inputs: Settings_Venues_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat pobočku`)
};

const en_settings_venues_delete = /** @type {(inputs: Settings_Venues_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete office`)
};

/**
* | output |
* | --- |
* | "Delete office" |
*
* @param {Settings_Venues_DeleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_delete = /** @type {((inputs?: Settings_Venues_DeleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_DeleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_delete(inputs)
	return cs_settings_venues_delete(inputs)
});